import axios from "axios";

const state = {
  generalIcons: [],
}

const mutations = {
  setGeneralIcons(state, payload) {
    state.generalIcons = payload
  }
}

const actions = {
  fetchGeneralIcons({ commit }) {
    axios.get('icon').then((response) => {
      commit('setGeneralIcons', response?.data || [])
    }).catch(() => commit('setGeneralIcons', []))
  },
  updateGeneralIcons({ dispatch }) {
    dispatch('fetchGeneralIcons')
  },
}

export default {
  state,
  mutations,
  actions,
}